import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ChatTongole from './components/Chat/ChatTongole';
import LayoutVarsController from './common/layoutVars';
import DownloadNotice from './common/downloadNotice';

// Stamp data-origin on <html> for theme-specific overrides
try {
  const originForAttr = (function () {
    const host = window.location.hostname.replace(/^www\./, '');
    const parts = host.split('.').filter(Boolean);
    return parts.length >= 2 ? parts[0] : host;
  })();
  document.documentElement.setAttribute('data-origin', originForAttr);
} catch {}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <ChatTongole/>
    <LayoutVarsController/>
    <DownloadNotice/>
    <App />
  </BrowserRouter>
);